import { sprintWeek, groupAssigneeNames } from '../model/taskManagement/TaskData'
import { weeklySummaries } from '../model/taskManagement/Summary'
const { getISOWeek } = require('date-fns');

const weekNumbers = [...Array.from(Object.keys(sprintWeek)).slice(1), Array.from(Object.keys(sprintWeek))[0]];

/**
 * Generate project task management data for pagination visualization of the group org project progress
 * @returns {[string[],string[],number]} array containing week numbers, group member names, and the current week number
 */
const getProgressPaginationData = () => {
    return [
        weekNumbers.map(week => `Week ${week}`),
        Object.values(groupAssigneeNames),
        sprintWeek[getISOWeek(new Date())]
    ];
}

/**
 * Get the weekly summary for a week number of the year corresponding to a week number in sprintWeek dictionary keys
 * @param {number} weekNumber the week number corresponding to a week of the year in the sprintWeek dictionary keys
 * @returns {string} the weekly summary mapped to the week of a year value in the weeklySummaries dictionary
 */
const getWeeklySummary = (weekNumber) => {
    return weeklySummaries[weekNumbers[weekNumber]];
}

export { getProgressPaginationData, getWeeklySummary };
